import React, { useState, useContext, useEffect } from "react";
import AppHeader from "../components/common/AppHeader";
import AppFooter from "../components/AppFooter";
import UserContext from "../contexts/UserContext";

import Utils from "./../Utils";

const HrLayout = ({ children }) => {
  const [loading, setLoading] = useState(
    (Utils.isHR() || Utils.isAMT()) && !Utils.hasBrand(),
  );
  const { userData } = useContext(UserContext);

  useEffect(() => {
    if (userData == null || userData == undefined || userData == false) {
      window.location.href = process.env.PUBLIC_URL + "/";
    }
    window.setTimeout(() => setLoading(false), 1000);
  }, [userData]);

  return (
    <div className="ftbottom">
      {loading && <div className="text-center">loading.. </div>}
      {!loading && (
        <div style={{ backgroundColor: "#c4ecea" }}>
          <div style={{ backgroundColor: "#81c4c0" }}>
            <AppHeader userType="hotel" />
          </div>
          {children}
          <AppFooter />
        </div>
      )}
    </div>
  );
};

export default HrLayout;
